'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosContact = function IoIosContact(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 3.8c8.9 0 16.2 7.2 16.2 16.2s-7.3 16.3-16.2 16.3-16.3-7.3-16.3-16.3 7.3-16.2 16.3-16.2z m0 31.1c4.6 0 8.6-2.1 11.4-5.4-1.6-0.6-5.2-1.8-7.3-2.5-0.2 0-0.2 0-0.2-0.8 0-0.7 0.3-1.3 0.5-1.8 0.3-0.7 0.6-1.7 0.7-2.5 0.3-0.4 0.8-1.1 1.1-2.5 0.2-1.3 0.2-1.7 0-2.2 0 0-0.1-0.1-0.1-0.2-0.1-0.3 0-1.8 0.3-2.9 0.1-0.8-0.1-2.7-1.2-4.1-0.7-0.9-2-2-4.5-2.2h-1.5c-2.4 0.2-3.8 1.3-4.5 2.2-1.1 1.4-1.3 3.3-1.2 4.1 0.3 1.1 0.4 2.6 0.3 2.9v0.2c-0.2 0.5-0.3 0.9-0.1 2.2 0.3 1.4 0.8 2.2 1.1 2.6 0.2 0.8 0.4 1.8 0.7 2.4 0.2 0.4 0.3 1 0.3 1.9 0 0.7-0.1 0.7-0.2 0.7-2.2 0.7-5.6 1.9-7.1 2.5 2.8 3.3 6.8 5.4 11.5 5.4z' })
        )
    );
};

exports.default = IoIosContact;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-contact.js
// module id = 2620
// module chunks = 168707334958949